import { t } from 'i18next';
import { useAtomValue } from 'jotai';
import { selectedRadarTemplateTitleSettingsAtom } from '@/atoms/radar';

export const useRadarTemplateName = () => {
  const titleSettings = useAtomValue(selectedRadarTemplateTitleSettingsAtom);

  if (!titleSettings) return t(`unknown`, { ns: 'general' });
  const { title, translate } = titleSettings;
  return translate ? t(`templates.${title}`, { ns: 'radar' }) : title;
};
